module.exports = __webpack_public_path__ + "images/landing/moving-trucks/stuff-trucks.svg";